import { AppSourceSelector } from '@/components/form/app-source-selector'

export const Source = () => <AppSourceSelector />
